import classNames from "shared/utils/classNames";

type Props = {
  isSent: boolean;
  isIframe: boolean | undefined;
  botAvatar: string;
  isLastMessage: boolean | undefined;
  isHidden?: boolean;
};

function MessageAvatar(props: Props) {
  const { isSent, isIframe, botAvatar, isLastMessage, isHidden } = props;

  if (isSent) {
    return;
  }

  const className = classNames(
    isIframe ? "h-8 w-8" : "h-7 w-7 min-w-[28px]",
    isIframe && isLastMessage && "wobble",
  );

  if (isHidden) {
    return <div className={className} />;
  }

  return <img className={className} src={botAvatar} />;
}

export default MessageAvatar;
